import { render, staticRenderFns } from "./insights.vue?vue&type=template&id=17ee8160&"
import script from "./insights.ts?vue&type=script&lang=js&"
export * from "./insights.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports